module.exports = __webpack_public_path__ + "img/pagination-left-arrow.5a21f9e4.svg";